import { render } from "./residualRisk.vue?vue&type=template&id=99f075b0&ts=true"
import script from "./residualRisk.vue?vue&type=script&lang=ts"
export * from "./residualRisk.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__